var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"city_box1"},[_c('div',{staticClass:"title"},[_vm._v("》"+_vm._s(_vm.title_in)+"《")]),_c('div',{staticClass:"city_img_box"},[_c('img',{staticStyle:{"width":"100%","height":"100%"},attrs:{"src":_vm.img_in}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }